import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { SponsorCreateRequest } from '~client/model/admin/sponsor-create-request';
import { SponsorResponse } from '~client/model/sponsor-response';

/* Admin APIs for maintaining sponsors */
export class AdminSponsorController extends BaseController {
  /* Allows an admin to create a sponsor */
  public createSponsor$(request: SponsorCreateRequest): Observable<SponsorResponse> {
    return this.post$('/admin/sponsor', request);
  }

  /* Allows an admin to list existing sponsors */
  public getSponsors$(): Observable<SponsorResponse[]> {
    return this.get$('/admin/sponsor/list');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/admin-sponsor-controller.ts